import { hasOwnProperty } from '@/utils/object';

export const mappingAttribute = {
	B: 'Blank Field',
	P: 'Parenthesis',
	S: 'Special Phone',
	N: 'N/A when 0',
	X: 'No data, print X',
	'2': 'Single Spaced',
	'3': 'Double Spaced',
	'4': 'Triple Spaced',
	M: 'Money right aligned',
	Z: 'If Result is zero, print blank ()',
	null: 'Nothing',
	U: 'Unrounded',
	V: 'Rounded'
};

export function attributeOptions() {
	let attr = { ...mappingAttribute };
	delete attr[null];
	let options = [];
	for (var key in attr) {
		if (hasOwnProperty(attr, key)) {
			options.push({ value: key, text: attr[key] });
		}
	}

	return options;
}
